import React from 'react';
import css from './SectionHeading.module.scss';

/**
 * @class
 *
 * A presentational heading component commonly found at the top of pages.
 *
 * @prop heading {string}: Heading text.
 * @prop subheading {string}: Subheading text.
 */
const SectionHeading = (props) => {
    return (
        <div className={css.SectionHeading}>
            <h1>{props.heading}</h1>
            <h4>{props.subheading}</h4>
        </div>
    );
};

export default SectionHeading;
